var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M331.24,443.17h-149.12c-5.37,0-10.03-.99-14.62-3.17-13.85-5.86-22.56-18.55-23.95-33.71l-.19-296.17c-.01-22.64,17.25-41.25,40.27-41.25l145.75-.02c20.79.51,37.75,16.49,39.16,37.24l-.02,300.78c-1.8,19.66-17.3,35.25-37.29,36.3ZM300,92.09l.04-8.86h-87.86s-.1,8.27-.1,8.27c-.05,4.3,3.09,7.4,7.5,7.4l74.07-.09c3.87,0,6.35-3.53,6.36-6.72ZM314.1,93.62c-1,9.99-8.96,19.2-19.67,19.22l-76.39.12c-9.97.02-19.88-9.62-20.02-20.41l-.13-9.38-17.62.2c-12.74,1.03-22.61,12.28-22.6,25.2l.09,295.84c0,12.69,10.61,24.26,23.34,24.29l146.86.32c14.41.03,26.5-10.25,26.5-25.13V106.26c-1.55-12.74-11.22-22.93-23.98-22.99l-16.23-.08-.14,10.44ZM306.29,402.79c-.03-3.54-2.73-7.16-6.92-7.16h-85.76c-4.32,0-7.43,2.85-7.68,6.66-.23,3.55,2.41,7.57,6.7,7.57h86.52c4.56.02,7.17-3.38,7.14-7.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobileIcon.b112ca0d3a25404fd285130a1f63efc2.svg";
export { ForwardRef as ReactComponent };